import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export enum VertragspartnerMode {
  VERWALTETER_KUNDE = 'VERWALTETER_KUNDE',
  ACCOUNT_KUNDE = 'ACCOUNT_KUNDE',
  BEARBEITBAR = 'BEARBEITBAR',
}
export interface AdresseFormValue {
  plz: string;
  ort: string;
  strasse: string;
  hausnummer: string;
  stiege: string;
  tuernummer: string;
}

export type VertragspartnerTyp = 'privat' | 'unternehmen' | null;

export interface PrivatpersonKontaktdatenFormValue {
  vorname: string;
  nachname: string;
  email: string;
  telefon: string;
  geburtsdatum: NgbDateStruct | null;
}

export interface UnternehmenKontaktdatenFormValue {
  name: string;
  geburtsdatum: NgbDateStruct | null;
  uid: string;
  firmenbuchnummer: string;
  email: string;
  telefon: string;
}

export interface PrivatUnternehmenFormValue {
  vertragspartnerTyp: VertragspartnerTyp;
  privatpersonKontaktdaten: PrivatpersonKontaktdatenFormValue | null;
  unternehmenKontaktdaten: UnternehmenKontaktdatenFormValue | null;
}
